var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRss = function SvgIconRss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.858 6.561A13.9 13.9 0 0 0 4.502 5.5a1 1 0 1 1-.004-2A15.92 15.92 0 0 1 15.81 8.19a15.92 15.92 0 0 1 4.69 11.312 1 1 0 1 1-2-.004 13.92 13.92 0 0 0-4.102-9.892l-.004-.004a13.9 13.9 0 0 0-4.536-3.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8a1 1 0 0 0 0 2 9.5 9.5 0 0 1 9.5 9.5 1 1 0 1 0 2 0A11.5 11.5 0 0 0 4.5 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.5a1 1 0 1 0 0 2 5 5 0 0 1 5 5 1 1 0 1 0 2 0 7 7 0 0 0-7-7M6.375 19.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconRss;